export const formatMoney = (amount: number | undefined) => (amount ? `$${amount?.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}` : 'Unknown')

export const stringToDate = (dateStr: Date | string | undefined) => (!!dateStr ? new Date(dateStr) : new Date())
